import { Toaster as SonnerToaster } from "sonner";

import UIcon from "../../lib/icons/untitled_ui/UIcon";

import css from "./Toaster.module.scss";

const Toaster = () => (
  <SonnerToaster
    offset={24}
    position="top-center"
    icons={{
      success: <UIcon icon="checkCircle" />,
      info: <UIcon icon="infoCircle" />,
      warning: <UIcon icon="alertCircle" />,
      error: <UIcon icon="xCircle" />,
      loading: <UIcon icon="spinner" />,
      close: <UIcon icon="xClose" />,
    }}
    toastOptions={{
      classNames: {
        toast: css.toast, // Uses data attributes to do all other styling
      },
    }}
  />
);

export default Toaster;
